var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIntegrityI(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 365,
    height: 487,
    viewBox: "0 0 365 487",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M167.2 0V486.4H0V471.2C58.7328 471.2 106.4 423.533 106.4 364.8V121.6C106.4 62.8672 58.7328 15.2 0 15.2V0H167.2Z",
    fill: "#FFFFFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M197.6 0V486.4H364.8V471.2C306.067 471.2 258.4 423.533 258.4 364.8V121.6C258.4 62.8672 306.067 15.2 364.8 15.2V0H197.6Z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntegrityI);
export default __webpack_public_path__ + "static/media/integrity-i.acc8f5883482f11c8e6a9e1d6bc160d1.svg";
export { ForwardRef as ReactComponent };